import { Package } from 'lucide-react';
import { useEffect, useState } from 'react';

interface OfflineProductThumbProps {
  src: string;
  /** Used when `src` is empty or the file fails to load. */
  fallbackSrc?: string;
  alt: string;
}

export function OfflineProductThumb({ src, fallbackSrc = '', alt }: OfflineProductThumbProps) {
  const sources = [src, fallbackSrc].filter(
    (url, index, all) => url.length > 0 && all.indexOf(url) === index,
  );
  const [attempt, setAttempt] = useState(0);
  const current = sources[attempt] ?? '';

  useEffect(() => {
    setAttempt(0);
  }, [src, fallbackSrc]);

  return (
    <span className="flex h-14 w-14 shrink-0 items-center justify-center overflow-hidden rounded-md border border-border bg-surface-muted">
      {current ? (
        <img
          src={current}
          alt={alt}
          className="h-full w-full object-contain"
          decoding="async"
          referrerPolicy="no-referrer"
          onError={() => setAttempt((value) => value + 1)}
        />
      ) : (
        <Package aria-hidden="true" className="h-5 w-5 text-fg-subtle" />
      )}
    </span>
  );
}
